/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "proto/timestamprange/models.proto" (package "rd.proto.timestamprange", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../google/protobuf/timestamp_pb";
// TimestampRange represents a date/time range. It can be an absolute range
// using `start` and `end`, or a relative range using `relative_type`.
// 
// For absolute ranges, `start` and `end` are used, and `relative_type` should be UNDEFINED.
// For example, to represent a specific week:
//   {
//     start: "2023-10-20T10:00:00Z",
//     end: "2023-10-27T10:00:00Z"
//   }
// 
// For relative ranges, `relative_type` is used. Some relative types also use
// `relative_start` and `relative_end`.
// 
// Examples of relative ranges:
// 
// Today:
//   { relative_type: RANGE_N_DAYS, relative_start: 0, relative_end: 0 }
// 
// Yesterday:
//   { relative_type: RANGE_N_DAYS, relative_start: 1, relative_end: 1 }
// 
// Past 10 days (from 9 days ago until today):
//   { relative_type: RANGE_N_DAYS, relative_start: 9, relative_end: 0 }
// 
// Week to date:
//   { relative_type: WEEK_TO_DATE }
// 
// Last month:
//   { relative_type: LAST_MONTH }

/**
 * @generated from protobuf message rd.proto.timestamprange.TimestampRange
 */
export interface TimestampRange {
    /**
     * absolute timestamp range
     *
     * @generated from protobuf field: google.protobuf.Timestamp start = 1
     */
    start?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp end = 2
     */
    end?: Timestamp;
    /**
     * The type of relative range. If this is `UNDEFINED`, `start` and `end` must be set.
     *
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange.RelativeType relative_type = 3
     */
    relativeType: TimestampRange_RelativeType;
    /**
     * `relative_start` should be greater than or equal to `relative_end`.
     * For `Past 10 days`, `relative_start` would be 9. `relative_end` would be 0.
     *
     * @generated from protobuf field: int32 relative_start = 4
     */
    relativeStart: number; // The start of the relative range, used with `RANGE_N_*` types.
    /**
     * @generated from protobuf field: int32 relative_end = 5
     */
    relativeEnd: number; // The end of the relative range, used with `RANGE_N_*` types.
}
/**
 * relative timestamp range
 *
 * @generated from protobuf enum rd.proto.timestamprange.TimestampRange.RelativeType
 */
export enum TimestampRange_RelativeType {
    /**
     * Not a relative range. `start` and `end` must be used for an absolute range.
     *
     * @generated from protobuf enum value: UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * A range of N days. `relative_start` and `relative_end` specify the
     * number of days ago.
     * e.g. for yesterday, relative_start = 1, relative_end = 1.
     * e.g. for past 7 days (6 days ago to today), relative_start = 6, relative_end = 0.
     *
     * A range of N days.
     *
     * @generated from protobuf enum value: RANGE_N_DAYS = 1;
     */
    RANGE_N_DAYS = 1,
    /**
     * A range of N weeks.
     *
     * @generated from protobuf enum value: RANGE_N_WEEKS = 2;
     */
    RANGE_N_WEEKS = 2,
    /**
     * A range of N months.
     *
     * @generated from protobuf enum value: RANGE_N_MONTHS = 3;
     */
    RANGE_N_MONTHS = 3,
    /**
     * A range of N years.
     *
     * @generated from protobuf enum value: RANGE_N_YEARS = 4;
     */
    RANGE_N_YEARS = 4,
    /**
     * The entire current day (e.g. today).
     *
     * @generated from protobuf enum value: TODAY = 5;
     */
    TODAY = 5,
    /**
     * The entire previous day (e.g. yesterday).
     *
     * @generated from protobuf enum value: YESTERDAY = 6;
     */
    YESTERDAY = 6,
    /**
     * The entire previous week (e.g. Sunday to Saturday).
     *
     * @generated from protobuf enum value: LAST_WEEK = 7;
     */
    LAST_WEEK = 7,
    /**
     * The entire previous month.
     *
     * @generated from protobuf enum value: LAST_MONTH = 8;
     */
    LAST_MONTH = 8,
    /**
     * The entire previous year.
     *
     * @generated from protobuf enum value: LAST_YEAR = 9;
     */
    LAST_YEAR = 9,
    /**
     * From the beginning of the current week to end of today.
     *
     * @generated from protobuf enum value: WEEK_TO_DATE = 10;
     */
    WEEK_TO_DATE = 10,
    /**
     * From the beginning of the current month to end of today.
     *
     * @generated from protobuf enum value: MONTH_TO_DATE = 11;
     */
    MONTH_TO_DATE = 11,
    /**
     * From the beginning of the current year to end of today.
     *
     * @generated from protobuf enum value: YEAR_TO_DATE = 12;
     */
    YEAR_TO_DATE = 12,
    /**
     * From the beginning of time to end of today.
     *
     * @generated from protobuf enum value: ALL_TIME = 13;
     */
    ALL_TIME = 13
}
// @generated message type with reflection information, may provide speed optimized methods
class TimestampRange$Type extends MessageType<TimestampRange> {
    constructor() {
        super("rd.proto.timestamprange.TimestampRange", [
            { no: 1, name: "start", kind: "message", T: () => Timestamp },
            { no: 2, name: "end", kind: "message", T: () => Timestamp },
            { no: 3, name: "relative_type", kind: "enum", T: () => ["rd.proto.timestamprange.TimestampRange.RelativeType", TimestampRange_RelativeType] },
            { no: 4, name: "relative_start", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "relative_end", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<TimestampRange>): TimestampRange {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.relativeType = 0;
        message.relativeStart = 0;
        message.relativeEnd = 0;
        if (value !== undefined)
            reflectionMergePartial<TimestampRange>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TimestampRange): TimestampRange {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp start */ 1:
                    message.start = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.start);
                    break;
                case /* google.protobuf.Timestamp end */ 2:
                    message.end = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.end);
                    break;
                case /* rd.proto.timestamprange.TimestampRange.RelativeType relative_type */ 3:
                    message.relativeType = reader.int32();
                    break;
                case /* int32 relative_start */ 4:
                    message.relativeStart = reader.int32();
                    break;
                case /* int32 relative_end */ 5:
                    message.relativeEnd = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TimestampRange, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp start = 1; */
        if (message.start)
            Timestamp.internalBinaryWrite(message.start, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp end = 2; */
        if (message.end)
            Timestamp.internalBinaryWrite(message.end, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange.RelativeType relative_type = 3; */
        if (message.relativeType !== 0)
            writer.tag(3, WireType.Varint).int32(message.relativeType);
        /* int32 relative_start = 4; */
        if (message.relativeStart !== 0)
            writer.tag(4, WireType.Varint).int32(message.relativeStart);
        /* int32 relative_end = 5; */
        if (message.relativeEnd !== 0)
            writer.tag(5, WireType.Varint).int32(message.relativeEnd);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.proto.timestamprange.TimestampRange
 */
export const TimestampRange = new TimestampRange$Type();
